module.exports = __webpack_public_path__ + "img/gartek-logo-green.1bae7378.svg";